import { useSelector } from 'react-redux';

const usePrimaryInterest = () => {
  const primaryInterest = useSelector(state => state.auth.currentUser.primary_interest);
  return primaryInterest;
};

export default usePrimaryInterest;
